import {
    createStoreFilter,
    StoreIdExtractor,
} from 'src/modules/store/extractors';
import { IStore } from 'src/interfaces/store';
import { DEFAULT_STORE_ID } from 'src/modules/store/constants/default';

const extractor = new StoreIdExtractor();

/**
 * Get all store ids by make
 * @param stores - The stores to get the store ids from
 * @param makeId - The make id to get the store ids from
 * @returns An array of store ids
 */

export const getStoreIdsByMake = (
    stores: IStore[],
    makeId: string,
    useFallback = true
): string[] => {
    const result = createStoreFilter(extractor)(stores, makeId);
    return useFallback && result.length === 0 ? [DEFAULT_STORE_ID] : result;
};
